// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fb771931","937":"1d2c06da"}[chunkId] + ".chunk.js";
};